import { render, staticRenderFns } from "./UsersPermissions.vue?vue&type=template&id=cf135822&scoped=true&"
import script from "./UsersPermissions.vue?vue&type=script&lang=js&"
export * from "./UsersPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UsersPermissions.vue?vue&type=style&index=0&id=cf135822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf135822",
  null
  
)

export default component.exports